var installedModules = {};
__webpack_require__.consumesLoadingData.moduleIdToConsumeDataMapping = {
	6204: {
		fallback: () => (__webpack_require__.e(21).then(() => (() => (__webpack_require__(31021))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: "^3.4.1",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "vue-axios",
	},
	7333: {
		fallback: () => (Promise.all([__webpack_require__.e(220), __webpack_require__.e(325)]).then(() => (() => (__webpack_require__(75220))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: "^4.1.5",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "vue-router",
	},
	9788: {
		fallback: () => (__webpack_require__.e(822).then(() => (() => (__webpack_require__(12822))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: "^1.19.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "axios",
	},
	12735: {
		fallback: () => (__webpack_require__.e(914).then(() => (() => (__webpack_require__(83533))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: "^1.23.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@shipbob/rbac",
	},
	21857: {
		fallback: () => (Promise.all([__webpack_require__.e(810), __webpack_require__.e(104)]).then(() => (() => (__webpack_require__(10810))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^3.0.4",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "pinia",
	},
	27715: {
		fallback: () => (__webpack_require__.e(36).then(() => (() => (__webpack_require__(21036))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: "^1.5.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@shipbob/telemetry",
	},
	35988: {
		fallback: () => (__webpack_require__.e(974).then(() => (() => (__webpack_require__(24974))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: "^4.4.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "exceljs",
	},
	74805: {
		fallback: () => (__webpack_require__.e(667).then(() => (() => (__webpack_require__(13667))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: "1.4.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@shipbob/auth",
	},
	89987: {
		fallback: () => (__webpack_require__.e(31).then(() => (() => (__webpack_require__(45031))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^3.5.30",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "vue",
	},
	90837: {
		fallback: () => (Promise.all([__webpack_require__.e(124), __webpack_require__.e(125)]).then(() => (() => (__webpack_require__(82124))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: "4.0.2",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "vuex",
	},
	40104: {
		fallback: () => (__webpack_require__.e(31).then(() => (() => (__webpack_require__(45031))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^3.5.11",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "vue",
	},
	13325: {
		fallback: () => (__webpack_require__.e(31).then(() => (() => (__webpack_require__(45031))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^3.2.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "vue",
	},
	74125: {
		fallback: () => (__webpack_require__.e(31).then(() => (() => (__webpack_require__(45031))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^3.0.2",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "vue",
	},
	10742: {
		fallback: () => (__webpack_require__.e(537).then(() => (() => (__webpack_require__(85537))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: "^4.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "jwt-decode",
	}
};
var moduleToHandlerMapping = {};
// no consumes in initial chunks
__webpack_require__.consumesLoadingData.chunkMapping = {
	"20": [
		6204,
		7333,
		9788,
		12735,
		21857,
		27715,
		35988,
		74805,
		89987,
		90837
	],
	"104": [
		40104
	],
	"125": [
		74125
	],
	"325": [
		13325
	],
	"742": [
		10742
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: __webpack_require__.consumesLoadingData.chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}